import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export default class ExperimentTransferDetails04CtaUpdate {
  static key = 'transfer-details-04-cta-update';

  static variations = {
    control: 'control',
    on: 'on',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isOn(): boolean {
    return this.currentVariant() === this.variations['on'];
  }

  static currentVariant(): string {
    return getFullVariant(this.key, { value: this.variations.control })
      .value as string;
  }
}
